
  import { LogHelper } from "@/common/LogHelper";
import {Component, Vue} from "vue-property-decorator";
  // import { AppModule } from "@/store/modules/app";
  // import { SingleStatistical } from "@/views/components";
  // import { UserModule } from "@/store/modules/user";
  // import Breadcrumb from "@/components/Breadcrumb/index.vue";
  // import Hamburger from "@/components/Hamburger/index.vue";

  @Component({
    name: "StatisticalData",
    components: {
      // SingleStatistical,
      // Breadcrumb,
      // Hamburger,
    },
    props: {
      dataSource: {
        type: Array,
        default: function () {
          return [];
        },
      },
    },
    watch: {
      dataSource: {
        handler(newone, oldone) {
          if (newone != null && newone.length > 0) {
            switch (newone.length) {
              case 1:
                this.oneelement = true;
                this.twoelement = false;
                this.threeelement = false;
                break;
              case 2:
                this.oneelement = false;
                this.twoelement = true;
                this.threeelement = false;
                break;

              case 3:
                this.oneelement = false;
                this.twoelement = false;
                this.threeelement = true;
                break;
              case 4:
                this.oneelement = false;
                this.twoelement = false;
                this.threeelement = true;
                break;
              default:
                this.oneelement = false;
                this.twoelement = false;
                this.threeelement = true;
                LogHelper.Error("统计数据收到的数据超过了4条，请检查数据");

                break;
            }
            var combinelist = [];
            newone.forEach((element) => {
              if (combinelist.indexOf(element.combine) == -1) {
                combinelist.push(element.combine);
              }
            });
            for (let index = 0; index < combinelist.length; index++) {
              var datalist = newone.filter(function (item) {
                return item.combine == String(index + 1);
              });
              if (datalist != null && datalist.length > 0) {
                this.maplist[index].label = "";
                this.maplist[index].value = "";
                for (let index1 = 0; index1 < datalist.length; index1++) {
                  this.maplist[index].label += datalist[index1].label;
                  this.maplist[index].value += datalist[index1].value;

                  if (index1 < datalist.length - 1) {
                    this.maplist[index].label += "/";
                    this.maplist[index].value += "/";
                  }
                }
              } else {
                LogHelper.Error("统计数据数组为空:" + String(index + 1));
              }
            }
          } else {
            LogHelper.Error("统计数据收到的数据为null或者是数组为空");
          }
        },
        immediate: true,
        deep: true,
      },
    },
  })
  export default class extends Vue {
    private inputModel = [{label: "", value: ""}];
    private oneelement = false;
    private twoelement = true;
    private threeelement = false;
    private maplist = [];
    private map1 = {label: "", value: ""};
    private map2 = {label: "", value: ""};
    private map3 = {label: "", value: ""};

    created() {
      this.maplist.push(this.map1);
      this.maplist.push(this.map2);
      this.maplist.push(this.map3);
    }
  }
